import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { doc, getFirestore, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

/** Sign in anonymously and resolve once we have a uid. Fine for a spike.
 *  Firebase persists the anonymous session in the browser (local persistence),
 *  so returning to the app later reuses the same uid — that's what lets the
 *  session list find sittings recorded on a previous visit. */
export async function ensureSignedIn(): Promise<string> {
  if (auth.currentUser) return auth.currentUser.uid;
  const cred = await signInAnonymously(auth);
  return cred.user.uid;
}

/** Light editing (M2): fix a garbled transcript line. Rules allow the session's
 *  owner to change only the `transcript` field of a recording. */
export function saveTranscript(docId: string, transcript: string): Promise<void> {
  return updateDoc(doc(db, "recordings", docId), { transcript });
}

/** Light editing (M2): name (or rename) a session. Rules allow the owner to
 *  change only the `title` field of their own session. */
export function saveSessionTitle(sessionId: string, title: string): Promise<void> {
  return updateDoc(doc(db, "sessions", sessionId), { title });
}
